<template>
  <div style="background-color: #fafafa;">
    <van-nav-bar
      title="库存余额表"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :z-index="998"
      fixed
    />
    <div class="psiConfirmCont">
      <div style="height:54px">
        <div style="width:20%;float:left; text-align: center;line-height:54px; font-size:10px">
          <span @click="showPicker">{{
            warehouseId === "" || warehouseId === "0"
              ? "选择仓库"
              : warehouseShowName
          }}</span>
        </div>
        <div style="width:80%; float:left;line-height:54px;">
          <van-search
            shape="round"
            v-model="skuInfoStr"
            placeholder="请输入商品编码或商品名称"
            show-action
            @search="onSearch"
            @cancel="onSearch"
          >
            <div slot="action" @click="onSearch">搜索</div>
          </van-search>
        </div>
      </div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
          finished-text="没有更多了"
        >
          <table class="layout">
            <thead>
              <tr>
                <th colspan="1" width="70%">
                  <span>商品名称</span>
                </th>
                <th colspan="1" width="30%">
                  <span>可用库存</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="tranData in list"
                class="card"
                :key="tranData.uuid"
                @click="openDetail(tranData.skuCode)"
              >
                <td colspan="1" height="50px">
                  <span>{{ tranData.skuName || "无" }}</span>
                </td>
                <td colspan="1" height="50px" align="center">
                  <span>{{ tranData.availableBalance || "0" }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-action-sheet
      v-model="show"
      :actions="actions"
      @select="chooseWarehouse"
      cancel-text="取消"
    />
  </div>
</template>

<script>
import {
  Tab,
  Tabs,
  Panel,
  Button,
  List,
  Search,
  Popup,
  PullRefresh,
  // Toast,
  NavBar,
  Tag,
  Col,
  ActionSheet,
  Row,
  Sidebar,
  SidebarItem,
  DatetimePicker,
  Field,
  DropdownMenu,
  DropdownItem,
  Icon,
} from "vant";
import userInfo from "../../store/userInfo";
import inventoryBalanceService from "../../service/electronicInventoryBalanceService";
import moment from "moment";
import { formatDictionary } from "../../utils/dictionary";
import { API_URL } from "../../common/config";

export default {
  data: function() {
    return {
      warehouseId: "",
      warehouseShowName: "",
      detailShow: false,
      selected: 0,
      list: [],
      loading: false,
      finished: false,
      pageIndex: 0,
      value: "",
      show: false,
      refreshing: false,
      type: 0,
      skuInfoStr: "",
      showTime: true,
      activeKey: 0,
      createTime: "",
      currDateType: 0,
      currCreateDateType: 0,
      currDisAdvisorDateType: 0,
      actions: [],
    };
  },
  store: userInfo,
  components: {
    [Tab.name]: Tab,
    [Tag.name]: Tag,
    [NavBar.name]: NavBar,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh,
    [Panel.name]: Panel,
    [List.name]: List,
    [Col.name]: Col,
    [Row.name]: Row,
    [Search.name]: Search,
    [Popup.name]: Popup,
    [Sidebar.name]: Sidebar,
    [SidebarItem.name]: SidebarItem,
    [DatetimePicker.name]: DatetimePicker,
    [Field.name]: Field,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet,
  },
  computed: {
    userId() {
      return this.$store.getters.getUserId;
    },
    avatarUrl() {
      return API_URL + "/oa/common/attachment/showImage?id=";
    },
  },
  created: async function() {
    let tabIndex = localStorage.getItem("allocationDataTabIndex");
    if (tabIndex === undefined || tabIndex === null) {
      tabIndex = 0;
      this.selected = 0;
      this.type = 0;
    } else {
      this.selected = parseInt(tabIndex);
      this.type = parseInt(tabIndex);
    }
  },
  methods: {
    async onLoad() {
      let r = await inventoryBalanceService.getZLSelectDict("psi_warehouse");

      if (r.data.Status == "1" && r.data.Data) {
        r.data.Data.push({ name: "取消选择", uuid: "0" });
        this.actions = r.data.Data;
      }
      this.pageIndex++;
      let resp = await inventoryBalanceService.getList(
        this.pageIndex,
        this.warehouseId,
        this.skuInfoStr
      );

      if (resp.data.Status == "1" && resp.data.Data.data.length > 0) {
        resp.data.Data.data.forEach((item) => {
          item.createTime = moment(item.createTime).format("YYYY-MM-DD");
        });
        formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      }
      this.loading = false;
      this.refreshing = false;
      formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      this.list = [...this.list, ...resp.data.Data.data];
      this.finished = resp.data.Data.total <= this.list.length;
    },
    onSearch() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    onRefresh() {
      this.finished = false;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    openDetail(id) {
      this.$router.push({
        path:
          "inventoryBalance/detail/" +
          id +
          "/" +
          (this.warehouseId === "" || this.warehouseId === "0"
            ? "0"
            : this.warehouseId),
      });
    },
    onClickLeft() {
      window.open("/colseWebView");
    },
    showPicker() {
      this.show = true;
    },
    async chooseWarehouse(item) {
      this.show = false;
      // eslint-disable-next-line no-undef
      this.warehouseId = item.uuid;
      this.warehouseShowName = item.name;
      this.onRefresh();
    },
  },
};
</script>

<style>
.dropdownItem > .van-dropdown-item > .van-popup {
  max-height: 100%;
  height: 100%;
}
.van-popup--right {
  width: 100%;
  height: 100%;
}
.van-nav-bar {
  z-index: 99999;
}
.tabs {
  margin-top: 120px;
}

.van-icon {
  margin-right: 0.6rem;
  color: #4090fa;
}

.icon {
  margin-left: 1rem;
}
</style>
